const FEEDBACK_ID = "clipboard-copy-feedback";
const FEEDBACK_TIMEOUT = 1200;

let feedbackTimer = null;

/**
 * Показывает короткое подтверждение копирования без создания нового toast.
 */
export function showClipboardCopyFeedback(message = "Скопировано") {
  if (typeof document === "undefined") return;

  let feedback = document.getElementById(FEEDBACK_ID);

  if (!feedback) {
    feedback = document.createElement("div");
    feedback.id = FEEDBACK_ID;
    feedback.setAttribute("role", "status");
    feedback.style.position = "fixed";
    feedback.style.top = "72px";
    feedback.style.right = "24px";
    feedback.style.zIndex = "10002";
    feedback.style.padding = "8px 12px";
    feedback.style.borderRadius = "6px";
    feedback.style.background = "#111827";
    feedback.style.color = "#fff";
    feedback.style.boxShadow = "0 8px 20px rgba(17, 24, 39, 0.18)";
    feedback.style.fontSize = "13px";
    feedback.style.lineHeight = "1.2";
    feedback.style.pointerEvents = "none";
    document.body.appendChild(feedback);
  }

  feedback.textContent = message;

  if (feedbackTimer) clearTimeout(feedbackTimer);

  feedbackTimer = setTimeout(() => {
    feedback.remove();
    feedbackTimer = null;
  }, FEEDBACK_TIMEOUT);
}
